import React, { FC, PropsWithChildren, useContext } from 'react';
import { ShieldShaded, Bullseye, Speedometer, FlagFill } from 'react-bootstrap-icons';
import ReactTooltip from 'react-tooltip'
import {v4 as uuidv4} from 'uuid';
import { ThemeContext, ThemeContextType, ThemeEnum } from '../ThemeProvider';
import './GridCell.css';

type GridCellProps = PropsWithChildren & {
    totPts: number,
    roundPts: number,
    lostPts: number,
    uptime: number,
    chkError: boolean,
    status: {
        ok: boolean,
        msg: string
    },
    sla_info: number[]
}

type SimpleGridCellProps = PropsWithChildren & {
    totPts: number,
}

const GridCell : FC<GridCellProps> = ({totPts, roundPts, lostPts, uptime, status, chkError, sla_info}) => {
    const tipId = uuidv4();
    const slaTipId = uuidv4();
    const { theme } = useContext(ThemeContext) as ThemeContextType;
    return <div className={`gridCell ${theme === ThemeEnum.light ? 'gridCell-light' : ''}`}>
        <div className="challExt">
            <div className="fr">
                <FlagFill />
                <span>{Math.round(totPts)}</span>
            </div>
            <div className="fr">
                <Bullseye />
                <span>{roundPts > 0 ? '+' : ''}{roundPts}</span>
            </div>
            <div className="fr">
                <ShieldShaded />
                <span>{lostPts > 0 ? '-' : ''}{lostPts}</span>
            </div>
            <div className="fr">
                <Speedometer />
                <span style={{cursor: "pointer"}} data-tip data-for={slaTipId}>{uptime}%</span>
            </div>
        </div> 
        <div className="pad">
            <div className={`statusDot${!status.ok ? ' err' : ''}${chkError && !status.ok ? ' chk-err' : ''}`} data-tip data-multiline data-for={tipId}/>
        </div>
        <ReactTooltip id={tipId} type={status.ok ? 'success' : 'error'} backgroundColor={status.ok ? "#18FF6D" : (chkError ? "gray" : "#E94F37")} textColor={status.ok ? "black" : "white"} arrowColor="transparent">{status.msg.split(",").map(t => <>{t}<br/></>)}</ReactTooltip>
        <ReactTooltip id={slaTipId} type='info' backgroundColor="gray" textColor="white" arrowColor="transparent">[{sla_info[0]}/{sla_info[1]}]</ReactTooltip>
    </div>;
}

export const SimpleGridCell : FC<SimpleGridCellProps> = ({totPts}) => {
    const { theme } = useContext(ThemeContext) as ThemeContextType;
    return <div className={`simpleGridCell ${theme === ThemeEnum.light ? 'simpleGridCell-light' : ''}`}>
        <div className="fr"><FlagFill /><span>{Math.round(totPts)}</span></div>
    </div>;
}

export default GridCell;